import React, { useEffect, useMemo, useState } from "react";
import { motion } from "framer-motion";
import { Database } from "lucide-react";
import { Panel } from "@/components/common/Panel";
import { EngineHero } from "@/components/common/EngineHero";
import { EngineFindingsTable } from "@/components/common/FindingDetailSheet";
import { staggerItem } from "@/lib/motion";
import { api } from "@/lib/api";

const RULES = [
    { label: "Proposal inconsistency (USOBX without USOBT)", category: "Proposal Inconsistency" },
    { label: "Obsolete proposals still active", category: "Obsolete Proposal" },
    { label: "Critical objects missing from the catalogue", category: "Missing Proposal" },
    { label: "Authorization inconsistencies across exports", category: "Authorization Inconsistencies" },
];

export default function SU24() {
    const [findings, setFindings] = useState([]);
    useEffect(() => {
        (async () => {
            const { data } = await api.get("/findings", { params: { engine: "su24" } });
            setFindings(data);
        })();
    }, []);

    const totals = useMemo(
        () => findings.reduce((acc, f) => ({ ...acc, [f.category]: (acc[f.category] || 0) + 1 }), {}),
        [findings],
    );

    return (
        <div className="space-y-6">
            <EngineHero
                testId="su24-engine-hero"
                icon={Database}
                engine="SU24"
                title="Proposal Consistency · Obsolescence · Default Authorization"
                blurb="Reads SU22/SU24 exports including USOBX_C and USOBT_C, then reports check-indicator inconsistencies, proposals that have gone obsolete against the shipped catalogue, and critical authorization objects that never made it into the proposal set at all."
                rules={RULES}
                totals={totals}
            />

            <motion.div variants={staggerItem} initial="initial" animate="animate">
                <Panel eyebrow={`${findings.length} findings`} title="SU24 Findings" testId="su24-findings-panel">
                    <EngineFindingsTable findings={findings} emptyHint="Upload SU24/SU22 exports and run analysis." />
                </Panel>
            </motion.div>
        </div>
    );
}
